import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotlightModuleWithHorizontalScroll',
  props: {
    showAllUrl: null,
    showInfo: { type: Boolean, default: true },
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {



const isMobileViewport = useMediaQuery('(max-width: 991px)');

return { __sfc: true,isMobileViewport, HiddenHorizontalScrollbar }
}

})